import AES from '@/common/libs/aes/aesLib.js';

const aes = new class {	
	encode(str, base64 = true) {
		let secret = this.getSecret();
		let iv = this.getIv();
		const aesLib = AES.AES;
		str = aesLib.encrypt(str, secret, iv);
		return !base64 ? str : new Buffer(str).toString('base64');
	}
	
	decode(str) {
		let secret = this.getSecret();
		let iv = this.getIv();
		str = new Buffer(str, 'base64').toString('utf8');
		const aesLib = AES.AES;
		return aesLib.decrypt(str, secret, iv);
	}
	
	getSecret() {
		let clientAgent = uni.$sk.func.getSecret();
		let secret = uni.$sk.func.md5(JSON.stringify(clientAgent));
		return secret.substr(0, 16);
	}
	
	getIv() {
		let clientAgent = uni.$sk.func.getSecret();
		let iv = uni.$sk.func.md5(JSON.stringify(clientAgent));
		return iv.substr(17, 16);
	}
}

export {
	aes
};